module.exports = __webpack_public_path__ + "img/kv-sp_x2.bd59421.jpg";